import { render, staticRenderFns } from "./dsUpModule.vue?vue&type=template&id=17ce2924&scoped=true"
import script from "./dsUpModule.vue?vue&type=script&lang=js"
export * from "./dsUpModule.vue?vue&type=script&lang=js"
import style0 from "./dsUpModule.vue?vue&type=style&index=0&id=17ce2924&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ce2924",
  null
  
)

export default component.exports